import getWithXHR from 'Common/utils/getWithXHR'

const url = '/api/v1/flashcards'

/**
 *
 * @param {number} flashcardId - flashcard ID
 * @returns {object} flashcard
 */
const getFlashcard = flashcardId => getWithXHR(`${url}/${flashcardId}`)

export default getFlashcard
